export interface TrainingSession {
    campaign_session_id: string;
    start_time: string;
    duration_max: number | string;
}
export interface TrainingGateFields {
    live_encounter_id: string | null;
    in_combat: 0 | 1;
    sessions: TrainingSession[];
    server_now: string;
}

/** campaign_session_start_time is UTC; duration_max is HOURS.
 * Server reference: db/campaign_sessions/build_campaign_session_arr.php:43-53.
 * Preserve an explicit offset; interpret raw MySQL DATETIME fields as UTC.
 */
export function trainingGroundsGate(input: {
    inCombat: boolean | number; sessions: readonly TrainingSession[]; now: string | number | Date;
}): { enabled: boolean; reason: 'in_combat' | 'session_live' | null } {
    if (input.inCombat) return { enabled: false, reason: 'in_combat' };
    const now = input.now instanceof Date ? input.now.getTime()
        : typeof input.now === 'number' ? input.now : Date.parse(input.now);
    for (const session of input.sessions) {
        const raw = session.start_time.trim().replace(' ', 'T');
        const start = Date.parse(/(?:Z|[+-]\d{2}:?\d{2})$/i.test(raw) ? raw : `${raw}Z`);
        const duration = Number(session.duration_max) * 60 * 60 * 1000;
        if (Number.isFinite(start) && Number.isFinite(duration) && duration >= 0 && now >= start && now <= start + duration) {
            return { enabled: false, reason: 'session_live' };
        }
    }
    return { enabled: true, reason: null };
}
